import { useEffect } from "react";
import {
  ACCESS_TOKEN_CLIENT,
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_UID,
  LOGIN_SUCCESS_POPUP_MESSAGE,
  SSO_POPUP_NAME,
} from "../dataAccess/constants";
import { setAuthorizationHeaders } from "./Authorization";
import { SSR } from "../helpers/environment";
import { getNonceKey } from "../dataAccess/SSO";
import { localStorageWrapper } from "../dataAccess/LocalStorage";
import type { User } from "../dataAccess/api/user";

export function useSSOPopupListener() {
  useEffect(() => {
    const handleMessage = (
      event: MessageEvent<{
        type: typeof LOGIN_SUCCESS_POPUP_MESSAGE;
        content: {
          accessToken: string;
          client: string;
          uid: string;
        };
      }>,
    ) => {
      if (
        event.origin.endsWith(".builtfirst.com") &&
        event.data?.type === LOGIN_SUCCESS_POPUP_MESSAGE
      ) {
        if (event.data.content?.accessToken) {
          const headers = new Headers();
          headers.set(ACCESS_TOKEN_KEY, event.data.content.accessToken);
          headers.set(ACCESS_TOKEN_CLIENT, event.data.content.client);
          headers.set(ACCESS_TOKEN_UID, event.data.content.uid);
          setAuthorizationHeaders(headers);
          window.location.reload();
        } else {
          console.error("Builtfirst SSO error: missing access data");
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
}

export function redirectIfSSOPopup(user: User | undefined) {
  if (!SSR && window.name === SSO_POPUP_NAME) {
    if (user) {
      const accessToken = localStorageWrapper.getItem(ACCESS_TOKEN_KEY) || "";
      const client = localStorageWrapper.getItem(ACCESS_TOKEN_CLIENT) || "";
      const uid = localStorageWrapper.getItem(ACCESS_TOKEN_UID) || "";
      window.opener?.postMessage(
        {
          type: LOGIN_SUCCESS_POPUP_MESSAGE,
          content: {
            accessToken,
            client,
            uid,
          },
        },
        "*",
      );
      window.close();
    }
    return true;
  }
}

export function openSSOPopup(url: string, provider: string) {
  const width = 600;
  const height = 650;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const popup = window.open(
    url,
    SSO_POPUP_NAME,
    `width=${width},height=${height},left=${left},top=${top}`,
  );
  const nonceKey = getNonceKey(provider);
  popup?.localStorage.setItem(
    nonceKey,
    localStorageWrapper.getItem(nonceKey) || "",
  );
}
